<template>
  <svg
    width="358"
    height="531"
    viewBox="0 0 358 531"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="358" height="81" rx="16" fill="#111111" />
    <rect x="12" y="12.5" width="56" height="56" rx="12" fill="#1F1F1F" />
    <path
      d="M46.4132 40.5908L46.1482 40.5251C48.4122 41.0494 50.7413 39.804 51.3501 37.6992C51.4985 37.1925 51.5372 36.6637 51.464 36.1431C51.3909 35.6225 51.2073 35.1204 50.9238 34.6657C50.6404 34.2111 50.2627 33.8128 49.8124 33.4938C49.3621 33.1748 48.8482 32.9414 48.3002 32.807L46.3875 32.3323L47.5242 28.4037L44.797 27.7269L43.6603 31.6556L41.4737 31.1132L42.6125 27.1777L39.8812 26.5L38.7424 30.4355L33.7366 29.1934L32.9401 31.9467L36.4248 32.8114L32.7813 45.4036L29.2965 44.5389L28.5 47.2922L33.5058 48.5343L32.3281 52.6046L35.0594 53.2823L36.2371 49.212L38.4238 49.7544L37.2466 53.8232L39.9737 54.5L41.1509 50.4311L43.4048 50.9906C46.5105 51.7613 49.7045 50.0538 50.5368 47.1773C51.3691 44.3008 49.5189 41.3615 46.4132 40.5908ZM40.919 33.8329L42.8885 34.3217L44.195 34.646C44.725 34.7775 45.1582 35.0355 45.4989 35.4021C46.0967 36.0015 46.3522 36.873 46.1083 37.7148C45.8649 38.5566 45.173 39.1935 44.3317 39.4354C43.8391 39.5951 43.3249 39.618 42.7944 39.4866L41.4879 39.1623L39.5184 38.6735L40.919 33.8329ZM42.1046 47.1345C42.0426 47.1379 42.0047 47.1286 41.9479 47.1145L39.3722 46.4752L37.4027 45.9864L38.8034 41.1458L40.7729 41.6347L43.3486 42.274C43.4053 42.2881 43.4432 42.2973 43.4953 42.329C44.8433 42.7199 45.6325 44.0623 45.2618 45.3428C44.8912 46.6233 43.4832 47.4203 42.1046 47.1345Z"
      fill="#FFB029"
    />
    <text
      fill="#999999"
      xml:space="preserve"
      style="white-space: pre"
      font-family="Inter"
      font-size="14"
      font-weight="600"
      letter-spacing="0.01em"
    >
      <tspan x="80" y="27.5909">Connected BTC Hashrate</tspan>
    </text>
    <text
      fill="#F5F5F5"
      xml:space="preserve"
      style="white-space: pre"
      font-family="Satoshi Variable"
      font-size="24"
      font-weight="bold"
      letter-spacing="0em"
    >
      <tspan x="80" y="60.24">{{ stats.hashrateShare }}</tspan>
      <tspan fill="#BFBFBF" font-size="20">Share</tspan>
    </text>

    <rect y="93" width="358" height="81" rx="16" fill="#111111" />
    <rect x="12" y="105.5" width="56" height="56" rx="12" fill="#1F1F1F" />
    <path
      d="M32.5072 137.679L25.5791 130.744L33.1877 123.135L44.6483 120.345L47.2412 122.938L32.5072 137.679ZM29.0363 130.744L32.5072 134.215L43.6002 123.122L34.4331 125.347L29.0431 130.737L29.0363 130.744Z"
      fill="#FF9900"
    />
    <path
      d="M49.6095 147.029L34.8823 132.309L39.7007 127.491L54.4211 142.211L49.6027 147.029H49.6095ZM38.3532 132.309L49.6095 143.565L50.9639 142.211L39.7007 130.955L38.3464 132.309H38.3532Z"
      fill="#FF9900"
    />
    <text
      fill="#999999"
      xml:space="preserve"
      style="white-space: pre"
      font-family="Inter"
      font-size="14"
      font-weight="600"
      letter-spacing="0.01em"
    >
      <tspan x="80" y="120.591">BTC Staked</tspan>
    </text>
    <text
      fill="#F5F5F5"
      xml:space="preserve"
      style="white-space: pre"
      font-family="Satoshi Variable"
      font-size="24"
      font-weight="bold"
      letter-spacing="0em"
    >
      <tspan x="80" y="153.24">{{ displayTokenValue(stats.btcTotalStaking) }}</tspan>
      <tspan fill="#BFBFBF" font-size="20">BTC</tspan>
    </text>

    <rect y="186" width="358" height="81" rx="16" fill="#111111" />
    <rect x="12" y="198.5" width="56" height="56" rx="12" fill="#1F1F1F" />
    <path
      d="M32.5072 230.679L25.5791 223.744L33.1877 216.135L44.6483 213.345L47.2412 215.938L32.5072 230.679ZM29.0363 223.744L32.5072 227.215L43.6002 216.122L34.4331 218.347L29.0431 223.737L29.0363 223.744Z"
      fill="#FF9900"
    />
    <path
      d="M49.6095 240.029L34.8823 225.309L39.7007 220.491L54.4211 235.211L49.6027 240.029H49.6095ZM38.3532 225.309L49.6095 236.565L50.9639 235.211L39.7007 223.955L38.3464 225.309H38.3532Z"
      fill="#FF9900"
    />
    <text
      fill="#999999"
      xml:space="preserve"
      style="white-space: pre"
      font-family="Inter"
      font-size="14"
      font-weight="600"
      letter-spacing="0.01em"
    >
      <tspan x="80" y="213.591">XSAT Staked</tspan>
    </text>
    <text
      fill="#F5F5F5"
      xml:space="preserve"
      style="white-space: pre"
      font-family="Satoshi Variable"
      font-size="24"
      font-weight="bold"
      letter-spacing="0em"
    >
      <tspan x="80" y="246.24">{{ displayTokenValue(stats.xsatTotalStaking) }}</tspan>
      <tspan fill="#BFBFBF" font-size="20">XSAT</tspan>
    </text>

    <rect y="279" width="358" height="54" rx="16" fill="#111111" />
    <text
      fill="#999999"
      xml:space="preserve"
      style="white-space: pre"
      font-family="Inter"
      font-size="14"
      font-weight="600"
      letter-spacing="0.01em"
    >
      <tspan x="16" y="311.091">Total Synced</tspan>
    </text>
    <text
      fill="#F5F5F5"
      xml:space="preserve"
      style="white-space: pre"
      font-family="Satoshi Variable"
      font-size="20"
      font-weight="bold"
      letter-spacing="0em"
    >
      <tspan x="150" y="313.7">{{ stats.parsedHeight || '-' }} BTC Blocks</tspan>
    </text>
    <rect y="345" width="358" height="54" rx="16" fill="#111111" />
    <text
      fill="#999999"
      xml:space="preserve"
      style="white-space: pre"
      font-family="Inter"
      font-size="14"
      font-weight="600"
      letter-spacing="0.01em"
    >
      <tspan x="16" y="377.091">BTC Validators</tspan>
    </text>
    <text
      fill="white"
      xml:space="preserve"
      style="white-space: pre"
      font-family="Satoshi Variable"
      font-size="20"
      font-weight="bold"
      letter-spacing="0em"
    >
      <tspan x="317" y="379.7">{{ stats.btcTotalValidators }}</tspan>
    </text>
    <rect y="411" width="358" height="54" rx="16" fill="#111111" />
    <text
      fill="#999999"
      xml:space="preserve"
      style="white-space: pre"
      font-family="Inter"
      font-size="14"
      font-weight="600"
      letter-spacing="0.01em"
    >
      <tspan x="16" y="443.091">XSAT Validators</tspan>
    </text>
    <text
      fill="white"
      xml:space="preserve"
      style="white-space: pre"
      font-family="Satoshi Variable"
      font-size="20"
      font-weight="bold"
      letter-spacing="0em"
    >
      <tspan x="300" y="445.7">{{ stats.xsatTotalValidators }}</tspan>
    </text>
    <rect y="477" width="358" height="54" rx="16" fill="#111111" />
    <text
      fill="#999999"
      xml:space="preserve"
      style="white-space: pre"
      font-family="Inter"
      font-size="14"
      font-weight="600"
      letter-spacing="0.01em"
    >
      <tspan x="16" y="509.091">Total Synchronizers</tspan>
    </text>
    <text
      fill="white"
      xml:space="preserve"
      style="white-space: pre"
      font-family="Satoshi Variable"
      font-size="20"
      font-weight="bold"
      letter-spacing="0em"
    >
      <tspan x="316" y="511.7">{{ displayTokenValue(stats.totalSynchronizers) }}</tspan>
    </text>
  </svg>
</template>
<script setup>
import { useTotalCount } from '@/page/Protocolintro/hook/useTotalCount.js'
const { stats, displayTokenValue } = useTotalCount()
</script>
